import React from "react";
import { twMerge } from "tailwind-merge";

const Pagination = ({ className, children }) => {
  return (
    <nav className={twMerge("flex justify-center w-full", className)}>
      <ul className="flex items-center gap-2">
        {children}
      </ul>
    </nav>
  );
};

const PaginationLink = ({ className, active, children, onClick, disabled }) => {
  return (
    <li className="flex-initial">
      <button
        onClick={onClick}
        disabled={disabled}
        className={twMerge([
          "min-w-0 sm:min-w-[40px] shadow-none font-normal flex items-center justify-center border-transparent text-slate-800 dark:text-slate-300 px-3 py-2 rounded-lg transition-colors",
          active && "text-white font-semibold",
          disabled && "opacity-50 cursor-not-allowed",
          className,
        ])}
        style={active ? { backgroundColor: '#2C5BA7' } : {}}
      >
        {children}
      </button>
    </li>
  );
};

Pagination.Link = PaginationLink;

export default Pagination;
